const styles = {
  contentWrapper: {
    padding: '24px 32px',
    maxWidth: '100%',
  },
  heading: {
    fontSize: '24px',
    fontWeight: 600,
    color: '#1a1a2e',
    marginBottom: '8px',
  },
  subheading: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '24px',
  },

  // Provider Cards
  providerGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '20px',
    marginTop: '24px',
  },
  providerCard: {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '24px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  providerCardHover: {
    borderColor: '#8BC34A',
    boxShadow: '0 4px 12px rgba(139, 195, 74, 0.15)',
  },
  providerName: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1a1a2e',
  },
  providerDescription: {
    fontSize: '13px',
    color: '#666',
    lineHeight: '1.5',
  },
  providerMeta: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    marginTop: '4px',
  },

  // Endpoint List
  endpointCard: {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '12px',
    transition: 'all 0.2s ease',
  },
  endpointCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  endpointName: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1a1a2e',
    cursor: 'pointer',
  },
  endpointStats: {
    display: 'flex',
    gap: '24px',
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '1px solid #f0f0f0',
  },
  statItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
  },
  statValue: {
    fontSize: '18px',
    fontWeight: 700,
    color: '#1a1a2e',
  },
  statLabel: {
    fontSize: '11px',
    color: '#999',
    textTransform: 'uppercase',
  },

  // Detail Tabs
  tabsContainer: {
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '24px',
  },

  // Profile Card
  profileCard: {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
    padding: '16px 20px',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'border-color 0.2s',
  },
  profileCardActive: {
    borderLeft: '4px solid #8BC34A',
  },
  profileCardInactive: {
    borderLeft: '4px solid #bdbdbd',
    opacity: 0.7,
  },

  // Rule Editor
  ruleRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 40px 1fr 140px 40px',
    gap: '12px',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #f5f5f5',
  },
  ruleArrow: {
    display: 'flex',
    justifyContent: 'center',
    color: '#8BC34A',
    fontSize: '20px',
    fontWeight: 700,
  },

  // Event Log
  statusChip: {
    COMPLETED: { backgroundColor: '#e8f5e9', color: '#2e7d32' },
    FAILED: { backgroundColor: '#ffebee', color: '#c62828' },
    SKIPPED: { backgroundColor: '#f5f5f5', color: '#757575' },
    PROCESSING: { backgroundColor: '#e3f2fd', color: '#1565c0' },
    RECEIVED: { backgroundColor: '#fff8e1', color: '#f57f17' },
    DEAD_LETTER: { backgroundColor: '#fce4ec', color: '#880e4f' },
  },

  // Secret display
  secretBox: {
    background: '#1a1a2e',
    borderRadius: '8px',
    padding: '16px',
    fontFamily: 'monospace',
    fontSize: '14px',
    color: '#8BC34A',
    wordBreak: 'break-all',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  // Empty state
  emptyContainer: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#999',
  },
  emptyText: {
    fontSize: '15px',
    marginTop: '12px',
  },

  // Template card
  templateCard: {
    background: '#f8faf5',
    border: '1px solid #c5e1a5',
    borderRadius: '10px',
    padding: '16px',
    marginBottom: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  templateCardHover: {
    background: '#f1f8e9',
    borderColor: '#8BC34A',
  },

  // JSON Viewer wrapper
  jsonViewerWrapper: {
    background: '#fafafa',
    borderRadius: '8px',
    padding: '16px',
    maxHeight: '400px',
    overflow: 'auto',
    border: '1px solid #e0e0e0',
  },
};

export default styles;
